import { httpClient } from "@/app/client/httpClient";
import { PageableRequest } from "@/types/PageableRequest";

class RankService {
  fetchRankList(
    query?: PageableRequest<{
      yearmonth__gte: string;
      yearmonth__lte: string;
    }>
  ) {
    return httpClient.accounts.me.worker_ranks.$get({
      query
    });
  }
}

export const rankService = new RankService();
